import UIP from '@uip-alpha/core'
import Base from '@uip-alpha/base-h5'
import Utils from '@uip-alpha/preset-utils'
import InterfaceRegion from '@uip-alpha/interface-region'
import BusinessGis from '@uip-alpha/business-gis'
import { utils as InterfaceGeoUtils, location as InterfaceLocation } from '@uip-alpha/interface-geo'
import wxapp from '@uip-alpha/wxapp-sdk'
import Sensor from '@uip-alpha/sensor-sdk-h5'
import { request } from '@uip-alpha/p-request'

const mode = window.env === 'PROD' ? 'PROD' : 'ALPHA'

const ENV = {
    SIT: 'sit',
    PROD: 'prod'
}

request.init({
    timeout: 20000,
    maxCache: 30,
    cacheTtl: 600,
    env: window.env === 'PROD' ? ENV.PROD : ENV.SIT
})
// try {
// 	setTimeout(
// 		() =>
// 			(UIP as any).http.intercept((config) => {
// 				SDK.authorize()
// 				return config
// 			}),
// 		0
// 	)
// } catch (e) {}

/**
 * uip 提供 http，storage等模块功能
 */
export default {
    ...UIP.use(
        Base,
        Utils,
        InterfaceRegion({
            configUrl: '/assets/config',
            mode
        }),
        BusinessGis({
            ak: '14e9ee810854c40f5ae9414f2a62c8cc',
            mode
        }),
        InterfaceGeoUtils,
        InterfaceLocation,
        wxapp({
            sign: {
                requestParams: {
                    url: '/wxopen/wxticket/getWxJSConfig'
                }
            },
            mode
        }),
        Sensor
    )
}



// WEBPACK FOOTER //
// ./src/util/uip.js